import { safeDayjs } from "@/helpers/dateHelper"
import { IStatus } from "@/types/Status"
import { IhdStatus, IIhdDetails, ihdStatuses } from "./ihdDetails.types"
import { Dayjs } from "dayjs"

export class IhdDetails implements IIhdDetails {
  deviceId: string
  deviceType: string
  deviceTypeName: string
  installedBy: string
  deviceStatus: IhdStatus | null
  responsiveStatus: string
  manufacturerCode: string
  manufacturerFullName: string
  manufacturerName: string
  model: string
  modelName: string
  smetsVersion: string
  firmwareVersion: string
  firmwareStatus: string
  mpan: string
  mprn: string
  dateInstalled?: Dayjs
  dateCommissioned?: Dayjs
  elecSsd?: Dayjs
  gasSsd?: Dayjs
  dateLastUpdated?: Dayjs

  constructor(
    deviceId: string,
    deviceType: string,
    deviceTypeName: string,
    installedBy: string,
    deviceStatus: IhdStatus | null | "",
    responsiveStatus: string,
    manufacturerCode: string,
    manufacturerFullName: string,
    manufacturerName: string,
    model: string,
    modelName: string,
    smetsVersion: string,
    firmwareVersion: string,
    firmwareStatus: string,
    mpan: string,
    mprn: string,
    dateInstalled?: string,
    dateCommissioned?: string,
    elecSsd?: string,
    gasSsd?: string,
    dateLastUpdated?: string,
  ) {
    this.deviceId = deviceId
    this.deviceType = deviceType
    this.deviceTypeName = deviceTypeName
    this.installedBy = installedBy
    this.deviceStatus = deviceStatus === "" ? null : deviceStatus
    this.responsiveStatus = responsiveStatus
    this.manufacturerCode = manufacturerCode
    this.manufacturerFullName = manufacturerFullName
    this.manufacturerName = manufacturerName
    this.model = model
    this.modelName = modelName
    this.smetsVersion = smetsVersion
    this.firmwareVersion = firmwareVersion
    this.firmwareStatus = firmwareStatus
    this.mpan = mpan
    this.mprn = mprn
    this.dateInstalled = safeDayjs(dateInstalled)
    this.dateCommissioned = safeDayjs(dateCommissioned)
    this.elecSsd = safeDayjs(elecSsd)
    this.gasSsd = safeDayjs(gasSsd)
    this.dateLastUpdated = safeDayjs(dateLastUpdated)
  }

  get ihdStatusType(): IStatus {
    return ihdStatuses[this.deviceStatus || IhdStatus.UNKNOWN]
  }
}
